var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 9.17785 7.5824",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M2.96715 0.829587C3.76543 -0.276531 5.41242 -0.276528 6.21069 0.82959L8.79607 4.41199C9.75067 5.73472 8.80551 7.5824 7.1743 7.5824H2.00355C0.372331 7.5824 -0.572817 5.73472 0.38178 4.41199L2.96715 0.829587Z",
    fill: "var(--fill-0, #002DA4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletTriangle);
export default __webpack_public_path__ + "static/media/bullet-triangle.5740112c8925bc9e7865777d1c5bfa4d.svg";
export { ForwardRef as ReactComponent };